import map from 'lodash/map';
import find from 'lodash/find';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';

import { convertLimitedTimeSlot, convertScheduledTimeSlot } from './datetime';

import dayjs from 'utils/dayjs';
import { expertAvailability } from 'constants/common';

const formatMultipleStringWithSeperator = (arr) => {
  if (!arr) return;

  const lastIdx = arr.length - 1;

  return arr.reduce(
    (prev, element, idx) => (prev += idx === 0 ? element : idx === lastIdx ? ` and ${element}` : `, ${element}`),
    '',
  );
};

export const formatPhoneNumber = (value) => {
  if (!value) return value;

  const currentValue = value.replace(/[^\d]/g, '');

  if (currentValue.length < 4) return currentValue;

  if (currentValue.length < 7) return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;

  return `${currentValue.slice(0, 3)}-${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
};

export const mapObjectsToSelectItems = (values) =>
  map(values, ({ name, ...obj }) => ({ ...obj, name, label: name, value: name }));

export const mapSelectItemsToObjects = (options, objects) =>
  map(options, ({ value }) => find(objects, (item) => value === item.name) || value);

export const formatTextAsNumber = (value, maxLength) => value.replace(/[^\d]/g, '').slice(0, maxLength);

export const filterValidFields = (object) => {
  const validFields = map(object, (value, key) => !isEqual(value, NaN) && value !== undefined && key);

  return pick(object, validFields);
};

export const transformProposedTimes = (proposedTimes) =>
  proposedTimes?.map((datetime, idx) => {
    const time = dayjs(datetime).format('hh:mma');

    return {
      id: idx + 1,
      date: datetime,
      time,
    };
  });

export const formatTimeSlotDescription = (timeSlot, tzName) => {
  const { kind } = timeSlot;

  if (kind === expertAvailability.SCHEDULED) {
    const convertedTimeSlot = convertScheduledTimeSlot(timeSlot, 'UTC', tzName);

    return `${
      convertedTimeSlot.days.length === 7
        ? 'Every day of the week'
        : formatMultipleStringWithSeperator(convertedTimeSlot.days.map((day) => `${day}s`))
    } from ${convertedTimeSlot.startTime} to ${convertedTimeSlot.endTime}`;
  } else if (kind === expertAvailability.SPECIFIC_DATES) {
    const convertedTimeSlot = convertLimitedTimeSlot(timeSlot, 'UTC', tzName);

    return (
      `From ${convertedTimeSlot.startDate} to ${convertedTimeSlot.endDate} ` +
      `at ${convertedTimeSlot.startTime} - ${convertedTimeSlot.endTime} daily`
    );
  }
};

export const getBlobFromCanvas = (ref) =>
  new Promise((resolve) => {
    if (ref.current) {
      ref.current.getImageScaledToCanvas().toBlob(resolve);
    } else {
      resolve(null);
    }
  });
